export default "__VITE_ASSET__DINo0Q3T__"